export default __webpack_public_path__ + "static/media/dashboard-white.baa73e9b.png";